import { InteractionType, EventSource, UserEvent, ComponentType } from '../UserEventsTypes';

export type ImporterEvents =
  | 'FILE_UPLOAD'
  | 'EXIT'
  | 'BACK'
  | 'NEXT'
  | 'IMPORT_DATA'
  | 'RESTART_IMPORT_DATA'
  | 'BACK_TO_SCREEN';

export const importerEvents: Record<ImporterEvents, UserEvent> = {
  FILE_UPLOAD: {
    eventDescription: 'Importer File Uploaded',
    eventKey: 'importer-file-uploaded',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.DROP,
    componentType: ComponentType.N_A
  },
  EXIT: {
    eventDescription: 'Importer Exit Clicked (Step #)',
    eventKey: 'importer-exit-clicked',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CONFIRM_BUTTON
  },
  BACK: {
    eventDescription: 'Importer Back Clicked (Step #)',
    eventKey: 'importer-back-clicked',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.INTERNAL_LINK_BUTTON
  },
  NEXT: {
    eventDescription: 'Importer Next Clicked (Step #)',
    eventKey: 'importer-next-clicked',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.INTERNAL_LINK_BUTTON
  },
  IMPORT_DATA: {
    eventDescription: 'Import Data Completed',
    eventKey: 'import-data-completed',
    eventSource: EventSource.SERVER_EVENT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  },
  RESTART_IMPORT_DATA: {
    eventDescription: 'Restart Import Data Clicked',
    eventKey: 'restart-import-data-clicked',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.INTERNAL_LINK_BUTTON
  },
  BACK_TO_SCREEN: {
    eventDescription: 'Back to Screen Clicked',
    eventKey: 'back-to-screen-clicked',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.INTERNAL_LINK_BUTTON
  }
} as const;
